import * as React from "react"

const ArrowRight = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={8}
        height={14}
        fill="#B91D1B"
        {...props}
        viewBox={'0 0 8 14'}
    >
        <path
            fill="inherit"
            stroke={'none'}
            d="M1.077 0 0 1.167 5.692 7 0 12.833 1.077 14 8 7 1.077 0Z"
        />
    </svg>
)

export default ArrowRight
